/* Bagulia: keep the cart drawer and header count in sync after any add-to-cart.
   The custom product page (bagulia-pdp) adds items with its own fetch and never
   re-rendered the drawer, so shoppers saw "Your cart (0)" until they reloaded.
   After every successful /cart/add request this re-renders the drawer and the
   header bubble from Shopify's Section Rendering API. (added 2026-10-12) */
(function () {
  "use strict";
  if (window.__baguliaCartSync) return;
  window.__baguliaCartSync = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var timer = null;

  function inner(html, selector) {
    var el = new DOMParser().parseFromString(html || "", "text/html").querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refresh() {
    var drawer = document.getElementById("CartDrawer");
    var bubble = document.getElementById("cart-icon-bubble");
    if (!drawer && !bubble) return;
    origFetch(root + "?sections=cart-drawer,cart-icon-bubble")
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerHtml = inner(sections["cart-drawer"], "#CartDrawer");
        if (drawer && drawerHtml !== null) {
          drawer.innerHTML = drawerHtml;
          drawer.classList.toggle("is-empty", !drawer.querySelector(".cart-item"));
        }
        var bubbleHtml = inner(sections["cart-icon-bubble"], ".shopify-section");
        if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
      })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = "";
    try {
      url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
    } catch (e) {}
    var result = origFetch.apply(this, args);
    if (String(url).indexOf("/cart/add") > -1) {
      result
        .then(function (res) {
          if (res && res.ok) {
            clearTimeout(timer);
            timer = setTimeout(refresh, 150);
          }
        })
        .catch(function () {});
    }
    return result;
  };
})();
